import * as React from 'react';
import Select from 'react-select';
import { IObservableObject, observable } from 'mobx';
import { observer } from 'mobx-react';
import { Typography } from '@material-ui/core';
import { translation } from '../../i18n';
import { SelectedQuestionCatalogue } from '../../pages/questionnaire/QuestionnaireForm';
import { QuestionCatalogueDto } from '../../pages/questionCatalogue/qustionCatalogueTypes';
import { getQuestionCatalogues } from '../../pages/questionCatalogue/questionCatalogueApi';
import { TextField } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { MenuItem } from '@material-ui/core';

interface Props {
  selectedCatalogue: SelectedQuestionCatalogue & IObservableObject,
}

function NoOptionsMessage(props: any) {
  return (
    <Typography
      color="textSecondary"
      style={{
        padding: `4px 8px`,
      }}
      {...props.innerProps}
    >
      {translation.t('catalogueSingleSelect.noOptions')}
    </Typography>
  );
}

// @ts-ignore
function inputComponent({ inputRef, ...props }) {
  return <div   style={{
    display: 'flex',
    padding: 0,
  }} ref={inputRef} {...props} />;
}

function Control(props: any) {
  return (
    <TextField
      label={translation.t('catalogueSingleSelect.label')}
      required={true}
      style={{marginTop: 8, marginBottom: 4}}
      InputLabelProps={{shrink: true,}}
      fullWidth={true}
      InputProps={{
        inputComponent,
        inputProps: {
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Menu(props:any) {
  return (
    <Paper square={true} style={{
      position: 'absolute',
      zIndex: 1,
      marginTop: 4,
      left: 0,
      right: 0,
    }} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

function Option(props: any) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

const component = {
  NoOptionsMessage,
  Control,
  Menu,
  Option
};

@observer
class QuestionCatalogueSingleSelect extends React.Component<Props> {
  public state = {
    single: null,
  };

  @observable private catalogues: QuestionCatalogueDto[] = [];

  constructor(props: Props) {
    super(props);
    this.loadCatalogues = this.loadCatalogues.bind(this);
  }

  public componentDidMount(): void {
    if (this.props.selectedCatalogue.questionCatalogue) {
      const currentCataloge = this.props.selectedCatalogue.questionCatalogue;
      this.setState({
        'single': {
          value: currentCataloge.id,
          label: currentCataloge.title,
          selectedCatalogue: currentCataloge,
        }
      })
    }
    this.loadCatalogues();
  }

  public render() {
    const {single} = this.state;

    return (
      <Select
        name={'name'}
        value={single}
        onChange={this.handleChange('single')}
        options={this.toOption()}
        isSearchable={true}
        components={component}
        placeholder={translation.t('catalogueSingleSelect.placeholder')}
      />
    );
  }

  private handleChange = (name: string) => (value: any) => {
    this.props.selectedCatalogue.questionCatalogue = value.selectedCatalogue;
    this.setState({
      [name]: value,
    });
  };

  private loadCatalogues = () => {
    getQuestionCatalogues({searchText: ''}, {page: 0, size: 1000000,}).then(page => {
      this.catalogues = page.content;
    });
  };

  private toOption = () => {
    return this.catalogues.map(
      (catalogue: QuestionCatalogueDto) => ({
        value: catalogue.id,
        label: catalogue.title,
        selectedCatalogue: catalogue,
      })
    )
  }

}

export default QuestionCatalogueSingleSelect;
